import { FEATURE, Actions, CommandActions, EventActions, DOWNLOAD_FILE,
         DOWNLOAD_COMMENTS, DOWNLOAD_FILES, DOWNLOAD_EXCEL_REPORT, DOWNLOAD_SSAB_TEMPLATE,
         DOWNLOAD_TEMPLATE, DOWNLOAD_OR_SHOW_FILE, DOWNLOAD_PROJECT_PACKAGE,
         DOWNLOAD_PROJECT_PACKAGE_STATUS, DOWNLOAD_PROJECT_PACKAGE_FILE, FETCH_PROJECT_DOWNLOADS,
         FETCH_REPORT_DOWNLOADS, DOWNLOAD_EXCEL_REPORT_FILE, DocumentActions} from "../../actions/documents";
import {ApiConfigActions} from "@pwbapps/reduxcore";
import { DocumentActions as NotificationDocumentActions} from "../../actions/notification";
import { CommandActions as LoaderCommandActions, DocumentActions as LoaderDocumentActions} from "../../actions/loader";
import { DocumentActions as UiDocumentActions } from "../../actions/ui";
import _ from 'lodash';
import { MessageBarType } from "@fluentui/react/lib/MessageBar";
import { canBePreviewed, formatDateFile, getFileExtension, getHistoryName } from "../../../utils/functions";
import { downloadFileUrl, downloadFilesUrl, downloadCommentsUrl, downloadExcelReportUrl, downloadSupplierTemplateUrl, downloadSSABExcelReportUrl, projectDownloadsUrl, projectDownloadStatusUrl, resolveProjectDownloadUrl, getProjectDocumentsUrl, getCheckTransmittalUrl, reportDownloadsUrl, reportDownloadStatusUrl } from "../../../utils/documentsUrls";
import { getDocuments, getProjectDownloads, getSelectedItemsIds } from "../../reducers/documents";
import { getGenericModal } from "../../selectors/ui";
import { saveAs } from 'file-saver';
import { getSelectedProjectCodeword, getSelectedProjectTemplate } from "../../selectors/project";
import { ModalCommandActions, ModalDocumentAction } from "../../actions/modal";
import { PreviewObject } from "../../../models/files";
import { t } from "i18next";
import { getSelectedProjectId, getProjects, getAllProjects } from "../../reducers/project";
import { getEmail } from "@pwbapps/reduxcore/dist/redux/reducers/auth";
import { Filters } from "../../../models/filters";

const projectDownloadPollingMs = 5000;
let projectDownloadsPollingTimeout: any;
const jsonHeaders = [
    {name: 'Accept', value: 'application/json'},
    {name: 'Content-Type', value: 'application/json'}
];
const jsonODataHeaders = [
    {name: 'Accept', value: 'application/json;odata.metadata=minimal;odata.streaming=true'},
    {name: 'Content-Type', value: 'application/json;odata.metadata=minimal;odata.streaming=true'}
];
const jsonODataAcceptHeaders = [{name: 'Accept', value: 'application/json;odata.metadata=minimal;odata.streaming=true'}];

interface ProjectDownloadResponse {
    jobId: string,
    projectId: number,
    downloadType?: 'project',
    transmittalId?: string | null,
    email?: string | null,
    exportParentFilesOnly?: boolean,
    status?: string,
    fileName?: string | null,
    downloadUrl?: string | null,
    blobName?: string | null,
    totalBytes?: number | null,
    processedBytes?: number | null,
    createdUtc?: string | null,
    completedUtc?: string | null,
    error?: string | null
}

interface ProjectDownloadsODataResponse {
    value?: ProjectDownloadResponse[]
}

interface ReportDownloadStartResponse {
    jobId: string,
    status?: string,
    email?: string | null,
    statusUrl?: string | null,
    downloadUrl?: string | null,
}

interface ReportDownloadStatusResponse {
    jobId: string,
    status?: string,
    email?: string | null,
    fileName?: string | null,
    downloadUrl?: string | null,
    expiresUtc?: string | null,
    progressPercentage?: number | null,
    totalRecords?: number | null,
    processedRecords?: number | null,
    createdUtc?: string | null,
    startedUtc?: string | null,
    completedUtc?: string | null,
    error?: string | null,
}

interface ReportDownloadListItem extends ReportDownloadStatusResponse {
    requestJson?: string | null,
    blobName?: string | null,
    downloadedUtc?: string | null,
    deletedUtc?: string | null,
}

interface ReportDownloadsODataResponse {
    value?: ReportDownloadListItem[]
}


export const documentsReportMiddlewareFunction = (history: any, dispatch: any, getState: any, next: any, action: Actions | ApiConfigActions.EventActions) => {

    switch (action.type) {

        case DOWNLOAD_OR_SHOW_FILE: {
            let id = action.payload.id;
            let fileName = action.payload.fileName;
            let clientNumber = action.payload.clientNumber;
            const showPreview = canBePreviewed(getFileExtension(fileName) as string);    
            if(!showPreview)
                dispatch(CommandActions.downloadFile({id, fileName, clientNumber}));
            else{
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: true }));
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', headers: [{name: 'Accept', value: 'application/octet-stream'}], responseType: 'arraybuffer', url: downloadFileUrl(id), feature: DOWNLOAD_FILE, returnObject: {id, fileName, showPreview, clientNumber}}}));         
            }
            break;
        }
 
        case DOWNLOAD_FILE: {
            let id = action.payload.id;
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: true, message:  'Downloading ' + action.payload.fileName + '...', messageType: MessageBarType.info })); 
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', headers: [{name: 'Accept', value: 'application/octet-stream'}], responseType: 'arraybuffer', url: downloadFileUrl(id), feature: DOWNLOAD_FILE, returnObject: {id, fileName: action.payload.fileName, clientNumber: action.payload.clientNumber}}}));    
            break;
        }

        case DOWNLOAD_FILES: {
            let downloadForm: {fileName?: string, isParent?: boolean, useClientNumberAsFilename?: boolean} = ((getGenericModal('fileName')(getState())) && (getGenericModal('fileName')(getState()) as any).contextItem) ? (getGenericModal('fileName')(getState()) as any).contextItem : 'Documents_Files';
            downloadForm = (downloadForm && !downloadForm.fileName) ? {...downloadForm, fileName: 'Documents_Files'} : downloadForm;
            const documentId: number | undefined = ((getGenericModal('fileName')(getState())) && (getGenericModal('fileName')(getState()) as any).optional) ? (getGenericModal('fileName')(getState()) as any).optional as number : undefined;
            let selectedItemIds = (!documentId) ? getSelectedItemsIds(getState()) : [documentId];
            selectedItemIds = (selectedItemIds.length === 0) ? _.map(getDocuments(getState()), d => (d.id as number).toString()) : selectedItemIds;
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: true, message:  'Downloading files...', messageType: MessageBarType.info })); 
              
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: {
                     method: 'POST', 
                     body: {
                        documentIds: [...selectedItemIds],
                        fileName: downloadForm.fileName,
                        isParent: downloadForm.isParent,
                        useClientNumberAsFilename: downloadForm.useClientNumberAsFilename
                     },
                     headers: [{name: 'Accept', value: 'application/octet-stream'}],
                     responseType: 'arraybuffer',
                     url: downloadFilesUrl(),
                     feature: DOWNLOAD_FILES,
                     returnObject: {fileName: downloadForm.fileName}
                }
            }));    
            break;
        }    
        
        case DOWNLOAD_COMMENTS: {
            const fileName: string = ((getGenericModal('comments')(getState())) && (getGenericModal('comments')(getState()) as any).optional) ? (getGenericModal('comments')(getState()) as any).optional as string : 'Documents_Comments';
            let documentIds = action.payload.documentIds;
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: true}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.info, message: t('Downloading comments') + '...'}));  
            if(documentIds.length > 0){
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                         method: 'POST', 
                         body: {
                            documentIds: [...documentIds],
                            fileName
                         },
                         headers: [{name: 'Accept', value: 'application/octet-stream'}],
                         responseType: 'arraybuffer',
                         url: downloadCommentsUrl(),
                         feature: DOWNLOAD_COMMENTS,
                         returnObject: {fileName}
                    }
                }));  
            }
           
            break;
        }

        case DOWNLOAD_EXCEL_REPORT: {
            const state = getState();
            const selectedProjectId = getSelectedProjectId(state);
            const reportFileName = getExcelReportFileName(state);
            const excelReportForm = ((getGenericModal('excelReport')(state)) ? (getGenericModal('excelReport')(state) as any).contextItem : undefined) || {};
            if(!selectedProjectId){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('Cannot complete download. Please retry.'), messageType: MessageBarType.error}));
                break;
            }
            const historyName = getHistoryName(history);

            dispatch(UiDocumentActions.setPanelStatus({open: true, title: t('Download menu'), content: 'downloadMenu'}));
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: {
                    method: 'POST',
                    body: {
                        projectId: selectedProjectId,
                        documentIds: getSelectedDocumentIdsForReport(getState),
                        fileName: reportFileName,
                        email: getEmail(state),
                        transmittalId: null,
                        isParent: false,
                        template: null,
                        useClientNumberAsFilename: false,
                        showAllversions: !!excelReportForm.showAllversions,
                        page: historyName
                    },
                    headers: jsonHeaders,
                    url: downloadExcelReportUrl(),
                    feature: DOWNLOAD_EXCEL_REPORT
                }
            }));
            break;
        }

        case DOWNLOAD_SSAB_TEMPLATE: {
            const fileName: string = 'TemplateMetadata';
            let documentIds = action.payload.documentIds;
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: true}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.info, message: t('Downloading report') + '...'}));  
            if(documentIds.length > 0){
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                         method: 'POST', 
                         body: {
                            documentIds: [...documentIds],
                            fileName
                         },
                         headers: [{name: 'Accept', value: 'application/octet-stream'}],
                         responseType: 'arraybuffer',
                         url: downloadSSABExcelReportUrl(),
                         feature: DOWNLOAD_SSAB_TEMPLATE,
                         returnObject: {fileName}
                    }
                }));  
            }
            break;
        }

        case DOWNLOAD_TEMPLATE: {
            let documentIds = action.payload.documentIds;
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: true}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.info, message: t('Downloading template') + '...'}));  
            if(documentIds.length > 0){
                
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                         method: 'POST', 
                         body: {
                            documentIds: [...documentIds],                          
                         },
                         headers: [{name: 'Accept', value: 'application/octet-stream'}],
                         responseType: 'arraybuffer',
                         url: downloadSupplierTemplateUrl(),
                         feature: DOWNLOAD_TEMPLATE,
                         returnObject: {fileName: 'Template'}
                    }
                }));  
            }
            break;
        }

        case DOWNLOAD_PROJECT_PACKAGE: {
            const selectedProjectId = getSelectedProjectId(getState());
            const transmittalId = _.trim(action.payload.transmittalId) || undefined;
            const exportParentFilesOnly = !!action.payload.exportParentFilesOnly;
            
            if(!selectedProjectId){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('Cannot complete download. Please retry.'), messageType: MessageBarType.error}));
                break;
            }
            
            if(transmittalId)
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({request: { method: 'GET', url: getCheckTransmittalUrl(getSelectedProjectId(getState()) as number, transmittalId), feature: 'DOWNLOAD_PROJECT_PACKAGE_CHECK_TRANSMITTAL', returnObject: {transmittalId, exportParentFilesOnly}}}));    
            else{
                dispatch(UiDocumentActions.setPanelStatus({open: true, title: t('Download menu'), content: 'downloadMenu'}));
    
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                        method: 'POST',
                        body: {
                            projectId: selectedProjectId,
                            transmittalId: transmittalId,
                            exportParentFilesOnly: exportParentFilesOnly,
                            email: getEmail(getState())
                        },
                        headers: jsonODataHeaders,
                        url: projectDownloadsUrl(),
                        feature: DOWNLOAD_PROJECT_PACKAGE,
                        returnObject: {transmittalId, exportParentFilesOnly}
                    }
                }));
            }
            break;
        }

        case FETCH_PROJECT_DOWNLOADS: {
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: {
                    method: 'GET',
                    headers: jsonODataAcceptHeaders,
                    url: projectDownloadsUrl(),
                    feature: FETCH_PROJECT_DOWNLOADS
                }
            }));

            const currentEmail = getEmail(getState());
            if(currentEmail){
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                        method: 'GET',
                        headers: jsonODataAcceptHeaders,
                        url: reportDownloadsUrl(currentEmail),
                        feature: FETCH_REPORT_DOWNLOADS
                    }
                }));
            }
            else{
                dispatch(DocumentActions.setValue({name: 'reportDownloads', value: []}));
                syncDownloadsPollingState(dispatch, getState);
            }
            break;
        }

        case DOWNLOAD_PROJECT_PACKAGE_FILE: {
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: {
                    method: 'GET',
                    headers: jsonODataAcceptHeaders,
                    url: projectDownloadStatusUrl(action.payload.jobId),
                    feature: DOWNLOAD_PROJECT_PACKAGE_FILE,
                    returnObject: {fileName: action.payload.fileName}
                }
            }));
            break;
        }

        case DOWNLOAD_EXCEL_REPORT_FILE: {
            dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                request: {
                    method: 'GET',
                    headers: jsonHeaders,
                    url: reportDownloadStatusUrl(action.payload.jobId),
                    feature: DOWNLOAD_EXCEL_REPORT_FILE,
                    returnObject: {fileName: action.payload.fileName}
                }
            }));
            break;
        }

       
        case ApiConfigActions.API_SUCCESS:
            apiSuccessMiddleware(history, dispatch, getState, next, action);         
            break;
    
        case ApiConfigActions.API_ERROR:
            apiErrorMiddleware(history, dispatch, getState, next, action);         
            break;

        default:
            break;
    }
};

const apiSuccessMiddleware = (history: any, dispatch: any, getState: any, next: any, action: ApiConfigActions.ApiSuccessAction) => {
    switch(action.meta.feature){

         case 'DOWNLOAD_PROJECT_PACKAGE_CHECK_TRANSMITTAL': {
           
            let documents = (action.payload) ? action.payload.value: [];
            if(documents.length > 0){
                dispatch(UiDocumentActions.setPanelStatus({open: true, title: t('Download menu'), content: 'downloadMenu'}));
    
                dispatch(ApiConfigActions.CommandActions.apiTokenRequest({
                    request: {
                        method: 'POST',
                        body: {
                            projectId: getSelectedProjectId(getState()) as number,
                            transmittalId: action.meta.returnObject.transmittalId,
                            exportParentFilesOnly: action.meta.returnObject.exportParentFilesOnly,
                            email: getEmail(getState())
                        },
                        headers: jsonODataHeaders,
                        url: projectDownloadsUrl(),
                        feature: DOWNLOAD_PROJECT_PACKAGE,
                        returnObject: {transmittalId: action.meta.returnObject.transmittalId, exportParentFilesOnly: action.meta.returnObject.exportParentFilesOnly}
                    }
                }));
            }    
            else{
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('The provided transmittal ID is not valid. Please check and retry.'), messageType: MessageBarType.error }));
            }
                                   
            break;
        }

        case DOWNLOAD_PROJECT_PACKAGE: {
            const response = action.payload as ProjectDownloadResponse;
            if(!response || !response.jobId){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('Cannot complete download. Please retry.'), messageType: MessageBarType.error }));
                break;
            }
            dispatch(CommandActions.fetchProjectDownloads());
            break;
        }

        case DOWNLOAD_EXCEL_REPORT: {
            const response = action.payload as ReportDownloadStartResponse;
            if(!response || !response.jobId){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('Cannot complete download. Please retry.'), messageType: MessageBarType.error }));
                break;
            }
            dispatch(CommandActions.fetchProjectDownloads());
            break;
        }

        case FETCH_PROJECT_DOWNLOADS:
        case DOWNLOAD_PROJECT_PACKAGE_STATUS: {
            const response = action.payload as ProjectDownloadsODataResponse;
            handleProjectDownloadsListResponse(dispatch, getState, response);
            break;
        }

        case FETCH_REPORT_DOWNLOADS: {
            const response = action.payload as ReportDownloadsODataResponse;
            handleReportDownloadsListResponse(dispatch, getState, response);
            break;
        }

        case DOWNLOAD_PROJECT_PACKAGE_FILE: {
            const response = action.payload as ProjectDownloadResponse;
            const downloadUrl = resolveProjectDownloadUrl(response && response.downloadUrl ? response.downloadUrl : undefined);
            if(!downloadUrl){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: t('Cannot complete download. Please retry.'), messageType: MessageBarType.error }));
                break;
            }

            startBrowserProjectDownload(downloadUrl, action.meta.returnObject.fileName as string);
            break;
        }

        case DOWNLOAD_EXCEL_REPORT_FILE: {
            const response = action.payload as ReportDownloadStatusResponse;
            const downloadUrl = resolveProjectDownloadUrl(response && response.downloadUrl ? response.downloadUrl : undefined);
            if(!downloadUrl){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: response && response.error ? response.error : t('Cannot complete download. Please retry.'), messageType: MessageBarType.error }));
                break;
            }

            startBrowserProjectDownload(downloadUrl, (response && response.fileName) || action.meta.returnObject.fileName as string);
            break;
        }
      
        case DOWNLOAD_FILE: {
            let document = action.payload;
            let id = action.meta.returnObject.id as number;
            let fileName = action.meta.returnObject.fileName as string;
            let showPreview = action.meta.returnObject.showPreview as boolean | undefined;
            let clientNumber = action.meta.returnObject.clientNumber as string | undefined;
            if(!showPreview && document && fileName) {
                let ext = getFileExtension(fileName);
                saveAs(new Blob([document]), `${(!clientNumber) ? fileName : (clientNumber + '.' + ext)}`);
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message:  t('Download completed'), messageType: MessageBarType.success, closeAutomatically: true }));
            }
            else if (showPreview && document && fileName){
                dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false }));
                let ext = getFileExtension(fileName);
                const normalizedExt = ext.toLowerCase();
                const contentTypeByExtension: {[key: string]: string} = {
                    pdf: 'application/pdf',
                    png: 'image/png',
                    jpg: 'image/jpeg',
                    jpeg: 'image/jpeg',
                    gif: 'image/gif',
                    bmp: 'image/bmp'
                };
                let blob = new Blob([document], {type: contentTypeByExtension[normalizedExt] || 'application/octet-stream'});
                let objectURL = URL.createObjectURL(blob);
                dispatch(ModalCommandActions.openModal({id: 'preview', contextItem: new PreviewObject({url: objectURL, ext: normalizedExt, id, fileName: (!clientNumber) ? fileName : (clientNumber + '.' + ext)})}));
            }
            break;
        }

        case DOWNLOAD_FILES: {
            let zip = action.payload;
            let fileName = action.meta.returnObject.fileName as string;
            if(zip) 
                saveAs(new Blob([zip]),`${fileName}.zip`);
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message:  t('Download completed'), messageType: MessageBarType.success, closeAutomatically: true }));
            break;
        }

        case DOWNLOAD_TEMPLATE:
        case DOWNLOAD_COMMENTS:
        case DOWNLOAD_SSAB_TEMPLATE: {
            let xlsx = action.payload;
            let fileName = action.meta.returnObject.fileName as string;
            const historyName = getHistoryName(history);
            if(xlsx) 
                saveAs(new Blob([xlsx]), action.meta.feature === DOWNLOAD_TEMPLATE ? `${fileName}.xlsm` : `${fileName}.xlsx`);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.success, message: t('Download completed')}));  
            setTimeout(() => { next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: false, type: MessageBarType.info, message: ''})); }, 5000);
            break;
        }
  
        default:
            break;
    }
}

const apiErrorMiddleware = (history: any, dispatch: any, getState: any, next: any, action: ApiConfigActions.ApiErrorAction) => {
    switch(action.meta.feature){

        case DOWNLOAD_PROJECT_PACKAGE:
        case FETCH_PROJECT_DOWNLOADS:
        case DOWNLOAD_PROJECT_PACKAGE_STATUS:
        case FETCH_REPORT_DOWNLOADS:
        case DOWNLOAD_EXCEL_REPORT:
        {
            stopProjectDownloadsPolling(dispatch);
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: getProjectDownloadErrorMessage(action), messageType: MessageBarType.error }));
            break;
        }

        case DOWNLOAD_PROJECT_PACKAGE_FILE: {
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: getProjectDownloadErrorMessage(action), messageType: MessageBarType.error }));
            break;
        }

        case DOWNLOAD_EXCEL_REPORT_FILE: {
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message: getProjectDownloadErrorMessage(action), messageType: MessageBarType.error }));
            break;
        }

        case DOWNLOAD_COMMENTS: {
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.error, message: t('Cannot download comments. Please retry.')}));
            break;
        }

        case DOWNLOAD_FILE: {
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message:  t('Cannot download this file. Please retry.'), messageType: MessageBarType.error }));
            break;
        }

        case DOWNLOAD_FILES: {
            dispatch(EventActions.setGridOrModalLoadersAndNotification({value: false, message:  t('Cannot download this files. Please retry.'), messageType: MessageBarType.error }));
            break;
        }

        case DOWNLOAD_TEMPLATE: {
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.error, message: t('Cannot download template. Please retry.')}));
            break;
        }

        case DOWNLOAD_SSAB_TEMPLATE: {
            const historyName = getHistoryName(history);
            dispatch(LoaderCommandActions.setLoadingContent({ feature: historyName, loading: false}));
            next(NotificationDocumentActions.setNotificationStatus({name: historyName, show: true, type: MessageBarType.error, message: t('Cannot download template. Please retry.')}));
            break;
        }
      
        default:
            break;
    }
}

const handleProjectDownloadsListResponse = (dispatch: any, getState: any, response: ProjectDownloadsODataResponse | undefined) => {
    const currentEmail = _.toLower(getEmail(getState()) || '');
    const visibleDownloads = _.map(
        _.filter(response && response.value ? response.value : [], download => {
            const status = _.toLower(download.status || '');
            const email = _.toLower(download.email || '');
            return email === currentEmail && !((download as any).deletedUtc) && (status === 'queued' || status === 'running' || status === 'completed' || status === 'failed' || status === 'expired');
        }),
        download => ({
            ...download,
            downloadType: 'project',
            status: download.status || 'Running',
            projectName: getProjectDownloadProjectName(getState, download.projectId)
        })
    );

    dispatch(DocumentActions.setValue({name: 'projectDownloads', value: visibleDownloads}));
    syncDownloadsPollingState(dispatch, getState);
};

const handleReportDownloadsListResponse = (dispatch: any, getState: any, response: ReportDownloadsODataResponse | undefined) => {
    const currentEmail = _.toLower(getEmail(getState()) || '');
    const visibleDownloads = _.map(
        _.filter(response && response.value ? response.value : [], download => {
            const status = _.toLower(download.status || '');
            const email = _.toLower(download.email || '');
            return email === currentEmail && !download.deletedUtc && (status === 'queued' || status === 'running' || status === 'completed' || status === 'failed');
        }),
        download => {
            const requestData = parseDownloadRequestJson(download.requestJson);
            const projectId = _.isNumber(requestData.projectId) ? requestData.projectId as number : undefined;
            return {
                ...download,
                downloadType: 'report',
                projectId,
                fileName: download.fileName || requestData.fileName,
                projectName: projectId ? getProjectDownloadProjectName(getState, projectId) : download.fileName || 'Report',
                status: download.status || 'Running'
            };
        }
    );

    dispatch(DocumentActions.setValue({name: 'reportDownloads', value: visibleDownloads}));
    syncDownloadsPollingState(dispatch, getState);
};

const syncDownloadsPollingState = (dispatch: any, getState: any) => {
    const projectDownloads = getProjectDownloads(getState()) || [];
    const hasRunningOrQueuedDownloads = _.some(projectDownloads, download => _.toLower(download.status || '') === 'running' || _.toLower(download.status || '') === 'queued');

    dispatch(DocumentActions.setValue({name: 'projectDownloadsPollingActive', value: hasRunningOrQueuedDownloads}));

    if(hasRunningOrQueuedDownloads)
        scheduleProjectDownloadsPolling(dispatch);
    else
        stopProjectDownloadsPolling(dispatch);
};

const getSelectedDocumentIdsForReport = (getState: any): number[] => _.chain(getSelectedItemsIds(getState()) || [])
    .map(id => Number(id))
    .filter(id => Number.isFinite(id))
    .value();

const getExcelReportFileName = (state: any): string => {
    const projectCodeword = _.trim(getSelectedProjectCodeword(state) || '') || 'Project';
    return `${projectCodeword}_Document Status Report_${formatDateFile(new Date())}.xlsx`;
};

const parseDownloadRequestJson = (requestJson?: string | null): {[key: string]: any} => {
    if(!requestJson)
        return {};
    try {
        return JSON.parse(requestJson);
    }
    catch {
        return {};
    }
};

const getProjectDownloadProjectName = (getState: any, projectId: number): string => {
    const project = _.find([...getProjects(getState()), ...getAllProjects(getState())], p => p.projectId === projectId);
    return (project && (project.projectCodeword || project.projectName)) ? (project.projectCodeword || project.projectName) as string : `Project ${projectId}`;
};

const scheduleProjectDownloadsPolling = (dispatch: any) => {
    clearTimeout(projectDownloadsPollingTimeout);
    projectDownloadsPollingTimeout = setTimeout(() => {
        dispatch(CommandActions.fetchProjectDownloads());
    }, projectDownloadPollingMs);
};

const stopProjectDownloadsPolling = (dispatch: any) => {
    clearTimeout(projectDownloadsPollingTimeout);
    projectDownloadsPollingTimeout = undefined;
    dispatch(DocumentActions.setValue({name: 'projectDownloadsPollingActive', value: false}));
};

const getProjectDownloadErrorMessage = (action: ApiConfigActions.ApiErrorAction): string => {
    const payload = action.payload as any;
    return (payload && (payload.message || payload.error || (payload.response && payload.response.data && (payload.response.data.message || payload.response.data.error)))) || t('Cannot complete download. Please retry.');
};

const startBrowserProjectDownload = (url: string, fileName: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.target = '_blank';
    downloadLink.rel = 'noopener noreferrer';
    downloadLink.download = fileName;
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};